const yjsObjectToPlainString = (yjsObject) => {
	if (yjsObject.type !== "doc" || !yjsObject.content) {
		return ""; // Handle unexpected object structure
	}

	function getTextFromNode(node) {
		if (node.type === "text") {
			return node.text;
		} else if (node.content) {
			// Recursively traverse nested content
			return node.content.map(getTextFromNode).join("");
		} else {
			return ""; // Handle unsupported node types (e.g., images)
		}
	}

	const plainText = yjsObject.content.map(getTextFromNode).join("\n\n"); // Join paragraphs with double newlines
	return plainText;
};

export default yjsObjectToPlainString;
